import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconThumbsUp"><Path fillRule="evenodd" clipRule="evenodd" d="M11.6302 2C11.0907 2 10.5928 2.28967 10.3262 2.75862L6.20911 10H3.5C2.67157 10 2 10.6716 2 11.5V19.5C2 20.3284 2.67157 21 3.5 21H17.4675C19.1739 21 20.6315 19.7695 20.9179 18.0873L21.8966 12.3373C22.2603 10.2004 20.6139 8.25 18.4462 8.25H13.601L14.1301 4.88876C14.3689 3.37171 13.1963 2 11.6605 2H11.6302ZM6 11V20H3.5C3.22386 20 3 19.7761 3 19.5V11.5C3 11.2239 3.22386 11 3.5 11H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbsUp;
